var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"background-color":"#ffffff"}},[_c('el-col',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"span":24}},[_c('img',{staticClass:"image-ad",attrs:{"src":_vm.propsImage,"loading":"lazy"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20ceee78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/advertisementTwo.vue
// module id = null
// module chunks = 